<script lang="ts">import { t, Verbiage } from "@infinitro/content";
import { getIcon } from "../data/icons";
const FavoritesTabIcon = getIcon("FavoritesTabIcon");
export let size = 20;
export let active = false;
export let hover = false;
export let color = undefined;
</script>

{#if typeof FavoritesTabIcon === 'string'}
	<img src={FavoritesTabIcon} alt={$t(Verbiage.icon_alt, 'alts')} />
{:else if typeof FavoritesTabIcon === 'function'}
	<svelte:component this={FavoritesTabIcon} {size} {active} {hover} {color} />
{:else}
	<span>Invalid icon</span>
{/if}

<style>
</style>
